import React, { Component } from 'react';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import MyWork from './MyWork';
import MyPro from './MyPro';
import OutPut from './OutPut';
import FinancialAnomalyReport from './FinancialAnomalyReport';
import InvPrincipal from './InvPrincipal';
import InvComplete from './InvComplete';

const roleList = {
    myWork: ['PM', 'PML', 'CRC', 'CRCC', 'CRCM'],
    myPro: ['PM', 'PML', 'VP', 'BO', 'FIN', 'BD', 'BDO', 'BDM', 'BA', 'BAL', 'CTA', 'CSA', 'CSAL', 'HRRC'],
    outPut: ['PM', 'PML', 'VP', 'BO', 'FIN', 'BD', 'BDO', 'BDM', 'BA', 'BAL', 'CRCC', 'CRCM', 'CSA', 'CSAL' , 'HRRC' ],
    //anomalyReport: ['PM', 'PML'],
    complete: ['BO', 'FIN', 'PML']
}

class MyFocus extends Component {
    state = {
        showInvPrincipal: false,
        showMywork: false,
        showMyPro: false,
        showOutPut: false,
        showAnomalyReport:false,
        showComplete: false,
    }

    componentDidMount() {
        const { curRole, isInvPM, isInvAreaLeader } = sessionStorage;
        const showMywork = roleList.myWork.includes(curRole);
        const showMyPro = roleList.myPro.includes(curRole);
        const showInvPrincipal = roleList.myPro.includes(curRole);
        const showOutput = roleList.outPut.includes(curRole);
        //const showAnomalyReport = roleList.anomalyReport.includes(curRole);
        const showComplete = roleList.complete.includes(curRole) || isInvPM || isInvAreaLeader;
        const { } = this.props;
        this.setState({
            showMywork,
            showMyPro,
            showOutput,
            showInvPrincipal,
            showComplete,
            //showAnomalyReport
        });
        this.queryFinErrorRole()
    }

    queryFinErrorRole=()=>{
        const{userId}=sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.home.queryFinErrorRole,
            data: {
                curUserId: userId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    showAnomalyReport: res.data,
                });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { showMywork, showMyPro, showOutput, showAnomalyReport, showComplete, showInvPrincipal } = this.state;
        const { isInvAreaLeader, isInvPM } = sessionStorage;
        return (
            <div className="tabWidth">
                <div className="flexBox" style={{ justifyContent: 'space-between' }}>
                    { showComplete && <InvComplete/> }
                    { (showInvPrincipal || isInvAreaLeader || isInvPM) &&<InvPrincipal/>}
                    { showAnomalyReport &&<FinancialAnomalyReport/>}
                    { showMywork && <MyWork /> }
                    { showMyPro && <MyPro /> }
                    { (!showMywork || !showMyPro) && showOutput && <OutPut /> }
                    {
                    (showMywork && showMyPro && showOutput) &&<OutPut />
                    }
                </div>
                {/* {
                    (showMywork && showMyPro && showOutput) &&
                    <div className="flexBox">
                        <OutPut />
                    </div>
                } */}
            </div>
        );
    }
}

export default MyFocus;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/index.js